import { h, render, Component } from 'preact';

export default class CountDown extends Component {
  constructor(props) {
    super(props);

    if (props.time) {
      const stamp = localStorage.getItem(`countDownStamp_${props.campaignId}`);
      if (stamp) {
        let span = parseInt(stamp - (new Date()) / 1000);
        span = Math.max(0, span);

        this.state = {
          span,
          finished: !span,
        };
        return;
      }


      const reDate = /^(\d+\/\d+\/\d+)\-?(\d*h?\d*)?$/;
      const reDay = /^([a-zA-Z]{3})\-?(\d*h?\d*)?$/;
      const reHour = /^(\d*h\d*)?$/;
      let time = props.time;
      if (props.time.split(' ').length > 1) {
        time = props.time.split(' ')[1];

        const pastTime = props.time.split(' ')[0];
        let pastDate = null;
        if (reDate.test(pastTime)) {
          pastDate = this.computeDate(reDate.exec(pastTime));
        } else if (reDay.test(pastTime)) {
          pastDate = this.computeDay(reDay.exec(pastTime), true);
        } else if (reHour.test(pastTime)) {
          pastDate = this.computeHour(reHour.exec(pastTime));
        }

        if (pastDate && pastDate - new Date() > 0) {
          this.state = { span: 0, finished: true };
          return;
        }
      }

      let futureDate = null;
      if (reDate.test(time)) {
        futureDate = this.computeDate(reDate.exec(time));
      } else if (reDay.test(time)) {
        futureDate = this.computeDay(reDay.exec(time), true);
      } else if (reHour.test(time)) {
        futureDate = this.computeHour(reHour.exec(time));
      }

      if (futureDate) {
        let span = parseInt((futureDate - (new Date())) / 1000);
        span = Math.max(span, 0);
        localStorage.setItem(`countDownStamp_${props.campaignId}`, `${parseInt(futureDate.getTime() / 1000)}`);

        this.state = {
          span,
          finished: !span,
        };
        return;
      }

      const span = parseInt(props.time);
      localStorage.setItem(`countDownStamp_${props.campaignId}`, `${parseInt(span + (new Date() / 1000))}`);
      this.state = {
        span,
        finished: !span,
      };
      return;
    }

    const stamp = localStorage.getItem('currentPrizeDate');
    if (!stamp) {
      this.state = {
        span: 0,
        finished: true,
      };
      return;
    }

    const timeStamp = new Date(parseInt(stamp) + 259200000);
    const span = parseInt((timeStamp - (new Date())) / 1000);

    this.state = {
      span,
      finished: false,
    };
  }

  componentDidMount() {
    if (this.state.finished) {
      localStorage.removeItem(`countDownStamp_${this.props.campaignId}`);
      this.props.refuseBlock();
      return;
    }
    this.interval = setInterval(() => {
      if ((this.state.span - 1) <= 0) {
        clearInterval(this.interval);
        localStorage.removeItem(`countDownStamp_${this.props.campaignId}`);
        this.props.refuseBlock();
      }
      this.setState(prevState => ({
        span: prevState.span - 1,
        finished: (prevState.span - 1) <= 0,
      }));
    }, 1000);
  }

  computeDate = (values) => {
    const day = values[1].split('/');
    const hour = values.length > 2 && values[2] ? values[2].split('h') : [0, 0];
    if (hour.length === 1) hour.push(0);

    const date = new Date(day[2], parseInt(day[1]) - 1, day[0], hour[0], hour[1]);

    return date;
  };

  computeDay = (values, noRecur = false) => {
    const days = {
      lun: 1, mar: 2, mer: 3, jeu: 4, ven: 5, sam: 6, dim: 7,
    };
    const hour = values.length > 2 && values[2] ? values[2].split('h') : [0, 0];
    if (hour.length === 1) hour.push(0);

    const date = new Date();
    date.setHours(hour[0], hour[1]);

    const daySpan = (days[values[1]] + (noRecur ? 0 : 7) - (date.getDay() ? date.getDay() : 7)) % 7;
    date.setDate(date.getDate() + daySpan);

    return date;
  };

  computeHour = (values) => {
    const hour = values[1].split('h');
    if (hour.length === 1) hour.push(0);

    const date = new Date();
    date.setHours(hour[0], hour[1]);

    return date;
  };

  getLabelSet = () => {
    if (this.props.label === 'no') {
      return {
        day: '', hour: '', minute: '', second: '',
        days: '', hours: '', minutes: '', seconds: '',
      };
    }
    if (this.props.label === 'short') {
      return {
        day: 'j', hour: 'h', minute: 'm', second: 's',
        days: 'j', hours: 'h', minutes: 'm', seconds: 's',
      };
    }
    return {
      day: ' jour', hour: ' heure', minute: ' minute', second: ' seconde',
      days: ' jours', hours: ' heures', minutes: ' minutes', seconds: ' secondes',
    };
  };

  render() {
    if (this.state.finished) { return <div />; }

    const label = this.getLabelSet();
    const days = Math.floor(this.state.span / (3600 * 24));
    const hRemain = days ? this.state.span % (days * 3600 * 24) : this.state.span;
    const hours = Math.floor(hRemain / 3600);
    const remain = hours ? hRemain % (hours * 3600) : hRemain;
    const minutes = Math.floor(remain / 60);
    const seconds = minutes ? remain % (minutes * 60) : remain;

    let dayString = '';
    let daylabel = '';
    if (days || this.props.showAll) {
      dayString = <span className="wio_countdown_number">{days}</span>;
      daylabel = <span className="wio_countdown_label">{days > 1 ? label.days : label.day} </span>;
    }

    let hString = '';
    let hlabel = '';
    if (hours || dayString || this.props.showAll) {
      hString += hours;
      if (dayString && hours < 10) {
        hString = `0${hours}`;
      }
      hString = <span className="wio_countdown_number">{hString}</span>;
      hlabel = <span className="wio_countdown_label">{hours > 1 ? label.hours : label.hour} </span>;
    }

    let minString = '';
    let minLabel = '';
    if (minutes || hString || this.props.showAll) {
      minString += minutes;
      if (hString && minutes < 10) {
        minString = `0${minutes}`;
      }
      minString = <span className="wio_countdown_number">{minString}</span>;
      minLabel = <span className="wio_countdown_label">{minutes > 1 ? label.minutes : label.minute} </span>;
    }

    let secString = '';
    let seclabel = '';
    if (seconds || minString || this.props.showAll) {
      secString += seconds;
      if (minString && seconds < 10) {
        secString = `0${seconds}`;
      }
      secString = <span className="wio_countdown_number">{secString}</span>;
      seclabel = <span className="wio_countdown_label">{seconds > 1 ? label.seconds : label.second}</span>;
    }

    return (
      <div
        id="wio_countdown"
        className="wio_countdown"
      >
        {dayString && daylabel ? <span className="wio_countdown_block">{dayString}{daylabel}</span> : null}
        {hString && hlabel ? <span className="wio_countdown_block">{hString}{hlabel}</span> : null}
        {minString && minLabel ? <span className="wio_countdown_block">{minString}{minLabel}</span> : null}
        {secString && seclabel ? <span className="wio_countdown_block">{secString}{seclabel}</span> : null}
      </div>
    );
  }
}
